export default __webpack_public_path__ + "static/media/H520753.273c2969.jpg";